import request from '@/utils/request'

let IndexApi = {
  // 基础配置
  base(data, errorback) {
    return request._post('/supplier/index/base', data, errorback);
  },

  // 首页数据
  getCount(data, errorback) {
    return request._post('/supplier/index/index', data, errorback);
  },

  // 专业详情
  getMajorDetail(data, errorback) {
    return request._post('/supplier/index/major', data, errorback);
  },

  // 填报须知
  getSignSetting(data, errorback) {
    return request._post('/supplier/index/index', data, errorback);
  },

  // 附件材料
  getFileList(data, errorback) {
    return request._post('/supplier/index/file', data, errorback);
  },


  // 云商通--2.6【会员绑定手机号申请】
  bindingPhone(data, errorback) {
    return request._post('/supplier/index/binding', data, errorback);
  },
  // 云商通--2.7【确认绑定/解绑手机号】
  bindingConfirm(data, errorback) {
    return request._post('/supplier/index/confirm', data, errorback);
  },



}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js